import { IconTile } from '../common/Icon';
import SectionCard from './SectionCard';

/**
 * PortfolioByType — six tinted tiles counting companies per entity type.
 * Owns the type-bucketing logic (moved verbatim from DashboardProPage).
 */
export default function PortfolioByType({ companies, onDetailedView }) {
  const typeCounts = companies.reduce((acc, company) => {
    const type = String(company.type || '').toLowerCase();
    if (type.includes('llp')) acc.llp += 1;
    else if (type.includes('public')) acc.public += 1;
    else if (type.includes('opc') || type.includes('one person')) acc.opc += 1;
    else if (type.includes('sec 8') || type.includes('ngo')) acc.sec8 += 1;
    else if (type.includes('foreign') || type.includes('nidhi') || type.includes('producer') || type.includes('government')) acc.other += 1;
    else acc.pvt += 1;
    return acc;
  }, { pvt: 0, llp: 0, public: 0, opc: 0, sec8: 0, other: 0 });

  const TYPE_CARDS = [
    { icon: 'portfolio', label: 'Private Ltd', value: typeCounts.pvt, color: '#4a6b3f' },
    { icon: 'llp', label: 'LLP', value: typeCounts.llp, color: '#3a4a66' },
    { icon: 'public-co', label: 'Public / Listed', value: typeCounts.public, color: '#8a6a1f' },
    { icon: 'opc', label: 'OPC', value: typeCounts.opc, color: '#3a4a66' },
    { icon: 'ngo', label: 'Sec 8 / NGO', value: typeCounts.sec8, color: '#4a6b3f' },
    { icon: 'governance', label: 'Other', value: typeCounts.other, color: '#9a564a' },
  ];

  return (
    <SectionCard icon="portfolio" iconTone="#4a6b3f" title="Portfolio by Company Type" action={{ label: 'Detailed View', onClick: onDetailedView }} className="mb-3.5">
      <div className="p-4 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2.5">
        {TYPE_CARDS.map((item) => (
          <div
            key={item.label}
            className="text-center px-2 py-3 rounded-[12px] border transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] hover:-translate-y-[2px] hover:shadow-[0_8px_20px_-6px_rgba(122,112,96,0.15)]"
            style={{ background: `${item.color}0a`, borderColor: `${item.color}2b` }}
          >
            <IconTile
              name={item.icon}
              size="md"
              tone={item.color}
              className="mb-2 mx-auto"
              style={{ background: '#ffffff', border: `1px solid ${item.color}15` }}
            />
            <div className="text-[20px] font-bold leading-tight" style={{ fontFamily: 'var(--font-serif)', color: item.color }}>{item.value}</div>
            <div className="text-[11px] font-bold tracking-wide mt-1" style={{ color: item.color }}>{item.label}</div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
}
